module.exports = __webpack_public_path__ + "fonts/TTNormsPro-MediumItalic.b826cd3d.ttf";